import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getkmlFilesPathByExploitationID } from "../../Utils/exploitations/map";
import Loading from "../Shared/Loading";
import GeoDataProcessor from "../../Hooks/map/GeoDataProcessor";
import GeoMarkProcessor from "../../Hooks/map/GeoMarkProcessor";

const MapExploitation = () => {
  const { explotId } = useParams();
  const [kmlfile, setKmlfiles] = useState([]);
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(false);
  const kmlPath = process.env.REACT_APP_KML_PATH;

  const getExploitationkmlPath = async () => {
    setLoading(true);
    try {
      const res = await getkmlFilesPathByExploitationID(explotId);
      const kmls = [];
      const exploitationId = res.data.exploitation.exploitation_id;
      kmls.push(
        ...res.data.exploitation.kml_files?.split(",").map((it) => ({
          url: kmlPath + it,
          isExploitation: true,
          exploitationId: exploitationId,
        }))
      );
      kmls.push(
        ...res.data.valves.flatMap((item) => {
          return item.kml_files?.split(",").flatMap((it) => {
            if (!it.trim()) return []; // Return an empty array if the KML file name is empty
            return [
              {
                url: kmlPath + it.trim(), // Make sure to trim any extra spaces
                isExploitation: false,
                exploitationId: exploitationId,
              },
            ];
          });
        })
      );

      const coordinates = res.data.points.map((item) => ({
        lat: parseFloat(item.coordinates?.split(",")[0]),
        lng: parseFloat(item.coordinates?.split(",")[1]),
        title: "point " + item.point_number,
        exploitation_id: exploitationId,
        exploitation: item,
      }));
      setPoints(coordinates);
      setKmlfiles(kmls);
    } catch (err) {
      setKmlfiles([]);
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getExploitationkmlPath();
  }, [explotId]);

  return (
    <>
      {loading && <Loading />}
      {kmlfile.map((kml, idx) => (
        <GeoDataProcessor
          key={idx}
          kmlUrl={kml.url}
          isExploitation={kml.isExploitation}
          exploitationId={kml.exploitationId}
        />
      ))}
      {points.length > 0 && (
        <GeoMarkProcessor markers={points} isSolPoint={true} />
      )}
    </>
  );
};

export default MapExploitation;
